import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import moment from 'moment';
import { take } from 'rxjs/operators';
import { selectPendoInitializeSuccess } from './pendo.selectors';
import { WindowRef } from './window-ref.services';
import { PendoState } from '@patient-help-center/store';
import * as PendoActions from './pendo.action';
@Injectable({
  providedIn: 'root',
})
export class PendoService {
  constructor(public windowRef: WindowRef, private store: Store<PendoState>) {}

  getPendoState(): boolean {
    let isInitializeSuccess = false;
    this.store
      .select(selectPendoInitializeSuccess)
      .pipe(take(1))
      .subscribe((state) => {
        isInitializeSuccess = state;
        return isInitializeSuccess;
      });
    return isInitializeSuccess;
  }

  pendoReady(): boolean {
    return (
      this.getPendoState() ||
      (typeof this.windowRef.nativeWindow.pendo.isReady === 'function' &&
        this.windowRef.nativeWindow.pendo.isReady())
    );
  }

  pendoInit(visitorInfo: any): void {
    if (this.pendoReady()) {
      this.windowRef.nativeWindow.pendo.identify(visitorInfo);
    } else {
      this.windowRef.nativeWindow.pendo.initialize(visitorInfo);
      this.store.dispatch(new PendoActions.PendoInitializeSuccess(true));
    }
  }

  setUnknownUser(): void {
    this.pendoInit({
      visitor: {
        Role: 'UnknownUser',
        Timestamp: moment().format('YYYY/MM/DD HH:mm:ss'),
      },
    });
  }
}
